export const BEARER_NAME = 'crm_auth_id';

export const ENV_DEV = 'development';
export const ENV_STAGE = 'stage';
export const ENV_PROD = 'production';
